import { AlertsSortField } from '@kirin/api-client/contracts/alerts';

/**
 * Maps each sortable/filterable alert column field to its URL state persistence key.
 * Use these constants instead of hardcoded strings anywhere a column key is needed
 * (column definitions, deep-link construction, URL parsing).
 *
 * `satisfies` ensures TypeScript enforces full coverage — adding a new AlertsSortField
 * value without a corresponding URL key here will be a compile error.
 */
export const USER_ALERTS_COLUMN_URL_KEYS = {
  [AlertsSortField.LastSeenAt]: 'ls',
  [AlertsSortField.Type]: 't',
  [AlertsSortField.Severity]: 'sev',
  [AlertsSortField.Outcome]: 'out',
  [AlertsSortField.FilePath]: 'fp',
  [AlertsSortField.OccurrenceCount]: 'oc',
  [AlertsSortField.Score]: 'sc',
  [AlertsSortField.FirstSeenAt]: 'fs',
  [AlertsSortField.ClientTypes]: 'ct',
} as const satisfies Record<AlertsSortField, string>;

/**
 * KIR-3769: URL state key for the composite "Title" filter (revamp on). Kept
 * separate from {@link USER_ALERTS_COLUMN_URL_KEYS} — which is keyed by
 * `AlertsSortField` and there is no Title sort field — and distinct from `t`
 * (Type) so old type-based deep links keep resolving to the Type filter.
 */
export const USER_ALERTS_TITLE_FILTER_URL_KEY = 'ti';
